import { FlexBox } from "@brg/ui";
import { FC } from "react";
import RadioButton from "shared/components/Radio";
import { ADMIN_TAGS_TYPE } from "../types";
import { useDispatch, useSelector } from "react-redux";
import { TagAdminActions, TagAdminSelector } from "shared/reducers/tagAdminSlice";
import { RadioContainer, TagsTypeLabel } from "../styles";
import { useTranslation } from "react-i18next";

const TagsTypeSwitcher: FC<{}> = () => {
    const dispatch = useDispatch();
    const {t, i18n: { language }} = useTranslation();
    const { type, currentPlatform } = useSelector(TagAdminSelector)

    const handleChange = (type:ADMIN_TAGS_TYPE) => {
        dispatch(TagAdminActions.setTagsType({
            currentPlatform: {
                ...currentPlatform,
                editCategory: null
            },
            type,
            isEditMode: false
        }))
    }
    
    return (
        <RadioContainer direction="row" gx={32}>
            <RadioButton
                checked={type === ADMIN_TAGS_TYPE.normal}
                onChange={() => handleChange(ADMIN_TAGS_TYPE.normal)}
                name="normal"
            >
                <TagsTypeLabel>{t('main_admin_tag.switcher.normal')}</TagsTypeLabel>
            </RadioButton>
            <RadioButton
                checked={type === ADMIN_TAGS_TYPE.education}
                onChange={() => handleChange(ADMIN_TAGS_TYPE.education)}
                name="education"
            >
                <TagsTypeLabel>{t('main_admin_tag.switcher.education')}</TagsTypeLabel>
            </RadioButton>
        </RadioContainer>
    )
}

export default TagsTypeSwitcher;import { FlexBox } from "@brg/ui";
import { FC } from "react";
import RadioButton from "shared/components/Radio";
import { ADMIN_TAGS_TYPE } from "../types";
import { useDispatch, useSelector } from "react-redux";
import { TagAdminActions, TagAdminSelector } from "shared/reducers/tagAdminSlice";
import { RadioContainer, TagsTypeLabel } from "../styles";
import { useTranslation } from "react-i18next";

const TagsTypeSwitcher: FC<{}> = () => {
    const dispatch = useDispatch();
    const {t, i18n: { language }} = useTranslation();
    const { type, currentPlatform } = useSelector(TagAdminSelector)

    const handleChange = (type:ADMIN_TAGS_TYPE) => {
        dispatch(TagAdminActions.setTagsType({
            currentPlatform: {
                ...currentPlatform,
                editCategory: null
            },
            type,
            isEditMode: false
        }))
    }
    
    return (
        <RadioContainer direction="row" gx={32}>
            <RadioButton
                checked={type === ADMIN_TAGS_TYPE.normal}
                onChange={() => handleChange(ADMIN_TAGS_TYPE.normal)}
                name="normal"
            >
                <TagsTypeLabel>{t('main_admin_tag.switcher.normal')}</TagsTypeLabel>
            </RadioButton>
            <RadioButton
                checked={type === ADMIN_TAGS_TYPE.education}
                onChange={() => handleChange(ADMIN_TAGS_TYPE.education)}
                name="education"
            >
                <TagsTypeLabel>{t('main_admin_tag.switcher.education')}</TagsTypeLabel>
            </RadioButton>
        </RadioContainer>
    )
}

export default TagsTypeSwitcher;